var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vuex-breadcrumb'),_c('actor-role-update',{attrs:{"id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }